<template>
  <div class="logistics-details">
    <nav-bar title="物流详情" left-text show-home></nav-bar>
    <div class="logistics-details-wrapper">
      <div class="logistics-intro" v-show="waybillNumber || company">
        <div class="name">物流公司：{{ company }}</div>
        <div class="number">运单编号：{{ waybillNumber }}</div>
        <!-- <div class="phone">查询电话：400-5789-425</div> -->
      </div>
      <div class="logistics-desc" v-show="timeLines.length">
        <ul class="time-lines">
          <li class="line" v-for="(line, index) in timeLines" :key="index">
            <span class="desc">{{ line.desc }}</span>
            <span class="time">{{ line.time }}</span>
          </li>
        </ul>
      </div>
      <div class="no-logistics-info" v-show="noLogistics">
        <p>暂无物流信息</p>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar'
export default {
  name: 'logisticsDetails',
  components: {
    NavBar
  },
  data () {
    return {
      company: '',
      waybillNumber: '',
      noLogistics: false,
      timeLines: []
    }
  },
  created () {
    this.getLogisticsDetails(this.$route.query.express)
  },
  methods: {
    async getLogisticsDetails (express) {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get(`api/exp/info/${express}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          if (data.content.length) {
            this.timeLines = data.content
          } else {
            this.noLogistics = true
          }
          this.company = data.company
          this.waybillNumber = data.number
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logistics-details {
}
.logistics-details-wrapper {
  margin-top: 0.26rem;
  padding: 0.2rem 0.2rem 0.8rem;
  background-color: #fff;
  .logistics-intro {
    font-size: @fz28;
    color: @base;
    line-height: 2;
    padding: 0.2rem 0.17rem 0.4rem;
    border-bottom: 0.5px solid #979797;
  }
  .logistics-desc {
    margin-top: 0.2rem;
    padding: 0 0.4rem;
    background-color: #fffcf8;
    .time-lines {
      padding-left: 0.32rem;
      border-left: 0.02rem solid #cda78f;
    }
    .line {
      position: relative;
      padding-top: 0.64rem;
      &::after {
        position: absolute;
        content: '';
        width: 0.2rem;
        height: 0.2rem;
        background-color: #cda78f;
        border-radius: 50%;
        left: -0.42rem;
        top: 0.74rem;
      }
      &:last-child {
        padding-bottom: 0.64rem;
      }
      .flex-column-between;
      .desc {
        color: #997762;
        font-size: @fz28;
        padding-bottom: 0.14rem;
      }
      .time {
        font-size: @fz24;
        color: #d6c7bb;
      }
    }
  }
}
</style>
